<template>
  <div class='q-pa-lg'>
    <div class="row justify-between items-start">
      <h1>Клиенты <span class="data-rows-number">{{ usersTotal }}</span></h1>
      <q-btn
        @click="newUser = true"
        color="primary"
        class="q-mt-sm"
      >
        Новый клиент
      </q-btn>
    </div>
    <user-create v-model="newUser" :redirect="true"/>
    <users-list/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import UsersList from '@/UsersList';
  import UserCreate from '@/UserCreate';
  import {
    QBtn
  } from 'quasar';

  export default {
    name: 'UsersView',
    components: {
      QBtn,
      UserCreate,
      UsersList
    },
    data () {
      return {
        newUser: false
      };
    },
    computed: mapGetters({
      usersTotal: 'usersList/total'
    })
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/UsersView.vue